'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.daysOfMonth = daysOfMonth;
exports.weekEnum = weekEnum;
exports.isDateFromNextMonth = isDateFromNextMonth;
exports.isDateFromPrevMonth = isDateFromPrevMonth;

function daysOfMonth(displayedMonth) {
  var _i = undefined,
      d = undefined;
  var results = [];
  var startAt = -displayedMonth.weekday() % 7;
  var endAt = Math.ceil((displayedMonth.daysInMonth() - startAt) / 7) * 7 + startAt - 1;

  for (d = _i = startAt; startAt <= endAt ? _i <= endAt : _i >= endAt; d = startAt <= endAt ? ++_i : --_i) {
    results.push(displayedMonth.clone().add(d, 'days'));
  }

  return results;
}

function weekEnum(daysOfMonth) {
  var results = [];

  for (var _i = 0, _ref = daysOfMonth.length / 7; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--) {
    results.push(_i);
  }
  return results;
}

function isDateFromNextMonth(date, displayedMonth) {
  return date.year() > displayedMonth.year() || date.year() === displayedMonth.year() && date.month() > displayedMonth.month();
}

function isDateFromPrevMonth(date, displayedMonth) {
  return date.year() < displayedMonth.year() || date.year() === displayedMonth.year() && date.month() < displayedMonth.month();
}


/** WEBPACK FOOTER **
 ** ./~/react-simple-datepicker/lib/utils/index.js
 **/